(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maslow-commissions"] && !Shopify.designMode) return;
  try {
    
function setupCommissionPage(root){
root.querySelectorAll('[data-commission-gallery]').forEach(gallery=>{
if(gallery.dataset.ready)return;gallery.dataset.ready='true';
gallery.querySelectorAll('[data-media-panel="finished_image"] img,[data-media-target="finished_image"] img').forEach(photo=>{const h=[0.974278437888,0.014178495117,-0.004092482654,-0.027009014268,0.989329731151,0.003450782308,-0.028620227912,0.005992211267];const straighten=()=>{const size=photo.clientWidth;if(!size)return;photo.style.transform='matrix3d('+[h[0],h[3],0,h[6]/size,h[1],h[4],0,h[7]/size,0,0,1,0,h[2]*size,h[5]*size,0,1].join(',')+')'};new ResizeObserver(straighten).observe(photo);straighten()});
const panels=[...gallery.querySelectorAll('[data-media-panel]')];const buttons=[...gallery.querySelectorAll('[data-media-target]')];
function selectMedia(key){panels.forEach(panel=>{const selected=panel.dataset.mediaPanel===key;panel.hidden=!selected;if(!selected){const video=panel.querySelector('video');if(video)video.pause()}});buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.mediaTarget===key)))}
buttons.forEach(button=>button.addEventListener('click',()=>selectMedia(button.dataset.mediaTarget)));
if(panels.length){selectMedia(panels[0].dataset.mediaPanel);gallery.querySelector('.mc-media-thumbs').hidden=false}
gallery.querySelectorAll('.mc-film-player').forEach(player=>{const video=player.querySelector('video');const button=player.querySelector('.mc-film-play');video.controls=false;button.hidden=false;button.addEventListener('click',()=>{video.controls=true;const playback=video.play();if(playback)playback.catch(()=>{button.hidden=false;video.controls=true})});video.addEventListener('playing',()=>button.hidden=true);video.addEventListener('ended',()=>{button.hidden=false;video.controls=false})});
});
root.querySelectorAll('[data-commission-form]').forEach(form=>{
if(form.dataset.ready)return;form.dataset.ready='true';const type=form.querySelector('[data-commission-type]');const school=form.querySelector('[data-school-fields]');const schoolInput=school.querySelector('input');const personalization=form.querySelector('[data-school-personalization]');
function updateType(){const isSchool=type.value==='school';school.hidden=!isSchool;schoolInput.required=isSchool;schoolInput.disabled=!isSchool;personalization.hidden=!isSchool;personalization.querySelector('input').disabled=!isSchool}
type.addEventListener('change',updateType);updateType();
form.addEventListener('change',event=>{if(event.target===type||event.target.name==='contact[Preferred size]'||event.target.name==='contact[Personalization upgrade]'){const field=form.querySelector('[data-commission-estimate-field]');if(field)field.disabled=true;const copy=form.querySelector('[data-commission-estimate-copy]');if(copy)copy.hidden=true}});
});
}
setupCommissionPage(document);document.addEventListener('shopify:section:load',event=>setupCommissionPage(event.target));
document.addEventListener('click',event=>{const calculatorLink=event.target.closest('[data-estimate-school-link]');if(calculatorLink){const calculator=document.querySelector('maslow-commission-estimate');const select=calculator?.querySelector('[data-estimate-type]');if(select){select.value='school';select.dispatchEvent(new Event('change',{bubbles:true}))}}const link=event.target.closest('[data-commission-choice]');if(!link)return;const type=document.querySelector('[data-commission-type]');if(type){type.value=link.dataset.commissionChoice;type.dispatchEvent(new Event('change',{bubbles:true}))}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maslow-etsy-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('maslow-etsy-reviews')) {
 customElements.define('maslow-etsy-reviews', class extends HTMLElement {
  connectedCallback() {
   if(this.dataset.ready)return;
   this.dataset.ready='true';
   const cards=Array.from(this.querySelectorAll('.mdc-review-card'));
   const more=this.querySelector('.mdc-review-more');
   const count=this.querySelector('.mdc-review-count');
   const filters=Array.from(this.querySelectorAll('[data-review-filter]'));
   let mode='all',shown=6;
   const chosen=()=>cards.filter(c=>mode==='all'||c.dataset.hasPhoto==='true');
   const display=()=>{const list=chosen();cards.forEach(c=>c.hidden=true);list.slice(0,shown).forEach(c=>c.hidden=false);count.textContent='Showing '+Math.min(shown,list.length)+' of '+list.length+(mode==='photos'?' photo reviews':' reviews');more.hidden=shown>=list.length;filters.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.reviewFilter===mode)))};
   filters.forEach(b=>b.addEventListener('click',()=>{mode=b.dataset.reviewFilter;shown=6;display()}));
   more.addEventListener('click',()=>{const first=shown;shown+=12;display();const card=chosen()[first];if(card){card.tabIndex=-1;card.focus({preventScroll:true})}});
   display();
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maslow-native-tray-preview"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('#native-tray-form').forEach(form=>{
 const root=form.closest('.native-tray');
 const money=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(n/100);
 const box=form.querySelector('.native-summary'),button=form.querySelector('[type=submit]');
 let busy=false;
 const update=()=>{let total=Number(form.querySelector('[name=tray]:checked').dataset.price);form.querySelectorAll('[data-fee]:checked').forEach(el=>total+=Number(el.dataset.fee));form.querySelector('[data-total]').textContent=money(total)};
 form.addEventListener('change',event=>{const input=event.target;
 if(input.name==='tray'){root.querySelector('.native-main-photo').src=input.dataset.image;root.querySelector('.native-main-photo').alt=input.dataset.title}
 if(input.name==='side1'||input.name==='side2'){const side=input.name.slice(-1);form.querySelector('[data-selected="'+side+'"]').textContent=input.value;const img=root.querySelector('[data-preview="'+side+'"]');img.src=input.dataset.image;img.hidden=false}
 if(input.matches('[data-fee]')){input.closest('.native-extra').querySelectorAll('select').forEach(select=>select.disabled=!input.checked)}
 box.hidden=true;update()});
 form.addEventListener('submit',async event=>{
 event.preventDefault();if(busy)return;
 const invalid=Array.from(form.elements).find(el=>el.willValidate&&!el.validity.valid);
 if(invalid){let parent=invalid.parentElement;while(parent&&parent!==form){if(parent.tagName==='DETAILS')parent.open=true;parent=parent.parentElement}invalid.reportValidity();invalid.focus();return}
 const tray=form.querySelector('[name=tray]:checked'),id=Number(tray.value);
 const configuration=crypto.randomUUID();
 const items=[{id,quantity:1,properties:{'Side 1 artwork':form.querySelector('[name=side1]:checked').value,'Side 2 artwork':form.querySelector('[name=side2]:checked').value,_maslow_preview_image:tray.dataset.image,_maslow_configuration:configuration}}];
 form.querySelectorAll('[data-fee]:checked').forEach(el=>{const selects=el.closest('.native-extra').querySelectorAll('select');items.push({id:el.name==='extra12'?47043066265647:47043066298415,parent_id:id,quantity:1,properties:{'Side 1 artwork':selects[0].value,'Side 2 artwork':selects[1].value,_maslow_preview_image:Array.from(form.querySelectorAll('[name=side1]')).find(art=>art.value===selects[0].value)?.dataset.image||'',_maslow_configuration:configuration}})});
 busy=true;button.disabled=true;button.textContent='Adding to cart…';box.hidden=true;
 try{const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok||result.status)throw new Error(result.description||result.message||'We could not add this selection. Please check your cart before trying again.');
 box.textContent='Added to your cart: '+tray.dataset.title+'\nSide 1: '+items[0].properties['Side 1 artwork']+'\nSide 2: '+items[0].properties['Side 2 artwork']+'\n'+(items.length-1)+' extra insert'+(items.length===2?'':'s')+'.';
 const link=document.createElement('a');link.href=(window.Shopify?.routes?.root||'/')+'cart';link.textContent='View your cart →';link.style.display='block';link.style.marginTop='12px';box.append(link);
 box.hidden=false;box.focus();
 }catch(error){box.textContent=error.message||'Please check your cart before trying again.';box.hidden=false;box.focus()}
 finally{busy=false;button.disabled=false;button.textContent='Add your tray to cart'}
 });update()
});

  } catch(e) { console.error(e); }
})();
})();
